export default __webpack_public_path__ + "static/media/check-verify.96470063.png";